// components/lendingLimits/LendingLimitsAccordion.tsx

import { GuarantorSummary } from './components/guarantorSummary/GuarantorSummary';
import { Core } from './components/core/Core';
import { Bridge } from './components/bridge/Bridge';
import { SBA } from './components/sba/SBA';
import { Rental } from './components/rental/Rental';
import { ILoanHistorySummaryTableRow } from './components/common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { IBLLSummary } from './components/common/constants/tables/interfaces/IBLLSummary';

interface LendingLimitsAccordionPanelProps {
    guarantor: string | undefined;
    business: string | undefined;
    hasMultipleBusinesses: boolean | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
    bllData: IBLLSummary | undefined;
}

export const LendingLimitsAccordionPanel: React.FC<LendingLimitsAccordionPanelProps> = ({
    guarantor,
    business,
    hasMultipleBusinesses,
    onLoanSummaryClick,
    bllData,
}) => (
    <div
        className='accordion'
        data-accordion=''
        data-allow-all-closed='true'
        data-multi-expand='true'
    >
        <GuarantorSummary
            guarantor={guarantor}
            business={business}
            hasMultipleBusinesses={hasMultipleBusinesses}
            onLoanSummaryClick={onLoanSummaryClick}
            guarantorSummaryData={bllData?.guarantorSummaryData}
        />
        <Core
            onLoanSummaryClick={onLoanSummaryClick}
            coreData={bllData?.coreData}
        />
        <Bridge
            onLoanSummaryClick={onLoanSummaryClick}
            bridgeData={bllData?.bridgeData}
        />
        <SBA
            onLoanSummaryClick={onLoanSummaryClick}
            sbaData={bllData?.sbaData}
        />
        <Rental
            onLoanSummaryClick={onLoanSummaryClick}
            rentalData={bllData?.rentalData}
        />
    </div>
);
